import { render, staticRenderFns } from "./ContestSwornCreateComponent.vue?vue&type=template&id=7563e17c&scoped=true"
import script from "./ContestSwornCreateComponent.vue?vue&type=script&lang=js"
export * from "./ContestSwornCreateComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestSwornCreateComponent.vue?vue&type=style&index=0&id=7563e17c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7563e17c",
  null
  
)

export default component.exports